import {Link, useFetcher, useLoaderData} from '@remix-run/react'
import {Anchor, Button} from '@translated/babele-react'
import clsx from 'clsx'

import {type action} from '~/routes/_action.hideCookieBanner'
import {type loader} from './route'

export const CookieBanner = () => {
  const loaderData = useLoaderData<typeof loader>()
  const cookieBanner = loaderData.cookieBanner
  const fetcher = useFetcher<typeof action>()

  if (cookieBanner.hidden) return

  return (
    <div
      className={clsx(
        'text-sm py-2.5 px-4 justify-center',
        'fixed w-full bottom-0 bg-primary-100 flex items-center gap-10',
      )}
    >
      <div>
        We use cookies to ensure that we give you the best experience on our
        website.{' '}
        <Anchor
          render={
            <Link to="/privacy" reloadDocument>
              Click here
            </Link>
          }
        >
          Click here
        </Anchor>{' '}
        for more information.
      </div>
      <fetcher.Form action="/hideCookieBanner" method="POST">
        <input type="hidden" name="_action" value="hideCookieBanner" />
        <Button
          type="submit"
          variant={{mode: 'outline', tone: 'primary'}}
          isLoading={fetcher.state == 'submitting'}
        >
          Got it
        </Button>
      </fetcher.Form>
    </div>
  )
}
